import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardBoldIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M15.86 11.47C18.18 11.37 20.11 10.02 20.11 6.65001C20.11 3.28001 17.85 1.01001 14.09 1.01001H3V23.01H15.11C18.48 23.01 21 20.21 21 16.74C21 12.96 18.02 11.48 15.86 11.48V11.47ZM7.98 5.03001H12.92C14.23 5.03001 15.01 5.79001 15.01 7.05001V8.00001C15.01 9.26001 14.22 10.02 12.92 10.02H7.98V5.04001V5.03001ZM15.83 16.98C15.83 18.24 15.01 18.97 13.7 18.97H7.97V13.93H13.7C15.01 13.93 15.83 14.65 15.83 15.92V16.99V16.98Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardBoldIcon.displayName = 'BoardBoldIcon';
